<p class="my-3 mb-4 color-medium">
  {{ description }}
</p>
